import Immutable from 'immutable';
import { setCloseStepValidation } from './closeStepValidation';
import { textUtils } from '../../utils/textUtils';

export const setCloseStep = (state, action) => {
  return state.setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'details', 'currentStep'
  ], action.step);
};

export const addCloseCode = (state, action) => {

  let currentCodes = state.getIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'closeCode'
  ]);

  currentCodes = currentCodes || new Immutable.List();

  if (currentCodes.count() === 3) {
    return state;
  }

  const orderDetails = state.getIn(['workOrderDetails', action.orderId, 'orderDetails', 'details']);
  const schedulingSystemDetails = state.getIn(['workOrderDetails', action.orderId, 'schedulingSystemDetails', 'details']);
  const codeToRemove = currentCodes.some(code => code.get('code') === action.request.primaryCode) && !action.request.secondaryCode;
  currentCodes = Immutable.fromJS([]);

  if (orderDetails && schedulingSystemDetails && !codeToRemove) {
    let addCloseCodeRequest = {
      username: action.request.username,
      code: action.request.primaryCode,
      orderSystem: schedulingSystemDetails.get('billingSystem'),
      accountNumber: orderDetails.get('accountNumber'),
      orderId: action.orderId,
      serviceTypeCode: schedulingSystemDetails.getIn(['serviceOrderInfoV2', 'serviceTypeId']),
    };

    currentCodes = currentCodes.push(Immutable.fromJS(addCloseCodeRequest));

    if (action.request.secondaryCode) {
      addCloseCodeRequest.code = action.request.secondaryCode;
      currentCodes = currentCodes.push(Immutable.fromJS(addCloseCodeRequest));
    }
  }

  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'closeCode'
  ], currentCodes);

  return setCloseStepValidation(state, action.orderId);
};

export const removeCloseCode = (state, action) => {

  let currentCodes = state.getIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'closeCode'
  ]);

  if (currentCodes) {
    let selectedPrimaryCode = currentCodes.find((exsistingCode) => {
      return exsistingCode.get('code') === action.request.primaryCode;
    });

    if (selectedPrimaryCode) {
      currentCodes = currentCodes.filter(code => code.get('code') !== action.request.primaryCode);
    }

    if (action.request.secondaryCode) {
      let selectedSecundaryCodes = selectedPrimaryCode.get('secondaryCodes');
      if (selectedSecundaryCodes) {
        selectedSecundaryCodes = selectedSecundaryCodes.filter(existingCode => existingCode.get('code') !== action.request.secondaryCode);
        currentCodes = currentCodes.push(selectedPrimaryCode.setIn(['secondaryCloseCodes'], selectedSecundaryCodes));
      } else {
        currentCodes = currentCodes.push(selectedPrimaryCode);
      }
    }
  }

  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'closeCode'
  ], currentCodes);

  return setCloseStepValidation(state, action.orderId);
};


export const setCloseComment = (state, action) => {

  const orderDetails = state.getIn(['workOrderDetails', action.orderId, 'orderDetails', 'details']);
  const schedulingSystemDetails = state.getIn(['workOrderDetails', action.orderId, 'schedulingSystemDetails', 'details']);

  if (orderDetails && schedulingSystemDetails) {
    action.request.orderSystem = schedulingSystemDetails.get('billingSystem');
    action.request.accountNumber = orderDetails.get('accountNumber');
    action.request.orderId = action.orderId;
    action.request.serviceTypeCode = schedulingSystemDetails.getIn(['serviceOrderInfoV2', 'serviceTypeId']);
    action.request.noAccessReasonId = state.getIn(['workOrderDetails', action.orderId, 'orderClose', 'details', 'closeOrderRequest', 'commentRequest', 'noAccessReasonId']);
  }

  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'commentRequest'
  ], Immutable.fromJS(action.request));

  return setCloseStepValidation(state, action.orderId);

};

export const setFstSignalValue = (state, action) => {

  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    action.request.errorLocation,
    'errors'
  ], action.request.errors).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    action.request.errorLocation,
    action.request.action + 'Error',
  ], action.request.errorMessage);

  if (action.request.storeLocation !== "pmTicketSignalLevel") {
    state = state.setIn([
      'workOrderDetails',
      action.orderId,
      'orderClose',
      'details',
      'closeOrderRequest',
      action.request.storeLocation,
      action.request.action
    ], action.request.value);
  }

  return setCloseStepValidation(state, action.orderId);
};

export const getDigitalChannelsStarted = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'channelsDetails',
    'error'
  ], false).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'channelsDetails',
    'errorMessage'
  ], null).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'channelsDetails',
    'highChannel'
  ], "").setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'channelsDetails',
    'lowChannel'
  ], "");

  return state;
};

export const getDigitalChannelsFinished = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'channelsDetails',
    'error'
  ], false).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'channelsDetails',
    'errorMessage'
  ], null).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'channelsDetails',
    'highChannel'
  ], action.request.highChannel).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'channelsDetails',
    'lowChannel'
  ], action.request.lowChannel);

  return state;
};

export const getDigitalChannelsFailed = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'channelsDetails',
    'error'
  ], true).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'channelsDetails',
    'channels'
  ], null).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'channelsDetails',
    'errorMessage'
  ], action.request.ErrorDescription).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'channelsDetails',
    'highChannel'
  ], "").setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'channelsDetails',
    'lowChannel'
  ], "");

  return state;
};


export const setTechIdSignalLevels = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'signalLevel',
    'techId'
  ], action.payload);

  return state;
};

export const submitTruckRollUnnecessaryStarted = (state, action) => {

  return state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'truckRoll',
    'submitPending'
  ], true).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'truckRoll',
    'unnecessary'
  ], action.request.truckRollUnnecessary).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'truckRoll',
    'submitSuccess'
  ], false).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'truckRoll',
    'submitAttempted'
  ], true).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'truckRoll',
    'submitMessage'
  ], 'Submission Sent');

};

export const submitTruckRollUnnecessaryFinished = (state, action) => {

  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'truckRoll',
    'submitPending'
  ], false).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'truckRoll',
    'submitSuccess'
  ], true)
    .setIn([
      'workOrderDetails',
      action.orderId,
      'orderClose',
      'details',
      'truckRoll',
      'submitAttempted'
    ], true).setIn([
      'workOrderDetails',
      action.orderId,
      'orderClose',
      'details',
      'truckRoll',
      'submitMessage'
    ], 'Submit Completed');

  return setCloseStepValidation(state, action.orderId);
};

export const submitTruckRollUnnecessaryFailed = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'truckRoll',
    'submitPending'
  ], false).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'truckRoll',
    'submitSuccess'
  ], false).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'truckRoll',
    'submitAttempted'
  ], true);

  return setCloseStepValidation(state, action.orderId);

};

export const setTruckRollUnecessaryValue = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'truckRoll',
    'truckRollUnnecessary'
  ], action.value);
  return setCloseStepValidation(state, action.orderId);
};

export const setTruckRollCloseComment = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'truckRoll',
    'truckRollCloseComment'
  ], action.comment);
  return setCloseStepValidation(state, action.orderId);
};

export const setCloseOrderStatus = (state, action) => {

  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'orderStatus'
  ], action.orderStatus).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'commentRequest',
    'noAccessReasonId'
  ], null);

  state = setCloseRequestCommon(state, action);

  return setCloseStepValidation(state, action.orderId);
};

export const setOutletOptimizationStatus = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'outletOptimizationStatus'
  ], action.optimizationStatus);

  return setCloseStepValidation(state, action.orderId);
};

export const setDropBury = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'auxiliary',
    'dropBury'
  ], action.value);

  return setCloseStepValidation(state, action.orderId);
};

export const addTicketRequest = (state, action) => {

  const orderDetails = state.getIn(['workOrderDetails', action.orderId, 'orderDetails', 'details']);
  const schedulingSystemDetails = state.getIn(['workOrderDetails', action.orderId, 'schedulingSystemDetails', 'details']);

  let currentTicketRequests = state.getIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'ticketRequests'
  ]);

  if (orderDetails && schedulingSystemDetails) {
    action.request.orderSystem = schedulingSystemDetails.get('billingSystem');
    action.request.accountNumber = orderDetails.get('accountNumber');
    action.request.orderId = action.orderId;
    action.request.serviceTypeCode = schedulingSystemDetails.getIn(['serviceOrderInfoV2', 'serviceTypeId']);
  }

  if (currentTicketRequests) {
    const selectedTicketIndex = currentTicketRequests.findIndex((exsistingTicket) => {
      return exsistingTicket.get('workType') === action.request.workType;
    });

    if (selectedTicketIndex < 0) {
      currentTicketRequests = currentTicketRequests.push(Immutable.fromJS(action.request));
    }
    if (selectedTicketIndex >= 0) {
      currentTicketRequests = currentTicketRequests.update(selectedTicketIndex, (item) => {
        return item
          .set('customerImpacting', action.request.customerImpacting)
          .set('comment', action.request.comment)
          .set('pmTicketSignalLevel', action.request.pmTicketSignalLevel)
      });
    }
  }

  if (!currentTicketRequests) {
    currentTicketRequests = Immutable.fromJS([action.request]);
  }

  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'ticketRequests'
  ], currentTicketRequests);

  return setCloseStepValidation(state, action.orderId);
};

export const removeTicketRequest = (state, action) => {

  let currentTicketRequests = state.getIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'ticketRequests'
  ]);

  if (currentTicketRequests) {
    const selectedTicketIndex = currentTicketRequests.findIndex((exsistingTicket) => {
      return exsistingTicket.get('workType') === action.workType;
    });

    if (selectedTicketIndex >= 0) {
      currentTicketRequests = currentTicketRequests.delete(selectedTicketIndex);
    }
  }

  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'ticketRequests'
  ], currentTicketRequests);

  return setCloseStepValidation(state, action.orderId);
};

export const orderCloseStarted = (state, action) => {
  //new set intermediate status orderClosing and send user to route
  if (state.getIn(['workOrderDetails', action.orderId, 'orderClose', 'orderClosingFinished'])) {
    return state;
  }
  //if the waiting screen is up, we don't change states
  if (state.getIn(['workOrderDetails', action.orderId, 'orderClose', 'orderClosingWaiting'])) {
    return state;
  }
  return state.setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'orderClosingStarted'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'orderClosingWaiting'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'orderClosingFinished'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'orderClosingError'
  ], null);
};

//new set intermediate status orderClosing and send user to route
export const orderCloseWaiting = (state, action) => {
  //If the order is finished, we don't reset the flags
  if (state.getIn(['workOrderDetails', action.orderId, 'orderClose', 'orderClosingFinished'])) {
    return state;
  }
  //If we did not start the clousure, we should do nothing
  if (!state.getIn(['workOrderDetails', action.orderId, 'orderClose', 'orderClosingStarted'])) {
    return state;
  }
  return state.setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'orderClosingStarted'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'orderClosingWaiting'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'orderClosingFinished'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'orderClosingError'
  ], null);
};

export const orderCloseFinished = (state, action) => {
  return state.setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'orderClosingStarted'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'orderClosingWaiting'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'orderClosingFinished'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'orderClosingError'
  ], null);
};

export const orderCloseFailed = (state, action) => {
  return state.setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'orderClosingStarted'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'orderClosingWaiting'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'orderClosingFinished'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'orderClosingError'
  ], 'Closing order failed.');
};

const setCloseRequestCommon = (state, action) => {
  const orderDetails = state.getIn(['workOrderDetails', action.orderId, 'orderDetails', 'details']);
  const schedulingSystemDetails = state.getIn(['workOrderDetails', action.orderId, 'schedulingSystemDetails', 'details']);

  if (!schedulingSystemDetails || !orderDetails) {
    return state;
  }

  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'orderId'
  ], action.orderId);

  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'serviceTypeCode'
  ], schedulingSystemDetails.getIn(['serviceOrderInfoV2', 'serviceTypeId']));

  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'orderSystem'
  ], schedulingSystemDetails.get('billingSystem'));

  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'accountNumber'
  ], orderDetails.get('accountNumber'));

  const sqcData = state.getIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'sqcInfoRequest',
    'data'
  ]);

  if (!sqcData) {
    state = state.setIn([
      'workOrderDetails',
      action.orderId,
      'orderClose',
      'details',
      'closeOrderRequest',
      'sqcInfoRequest',
      'data'
    ], new Immutable.List());
  }

  return state;
};

export const setOrderCloseRequestAddStarted = (state, action) => {
  if (state.getIn(['workOrderDetails', action.orderId, 'orderClose', 'closeOrderRequestAddFinished'])) {
    return state;
  } else {
    return state.setIn([
      'workOrderDetails', action.orderId, 'orderClose', 'closeOrderRequestAddStarted'
    ], true).setIn([
      'workOrderDetails', action.orderId, 'orderClose', 'closeOrderRequestAddFinished'
    ], false).setIn([
      'workOrderDetails', action.orderId, 'orderClose', 'closeOrderRequestAddError'
    ], null);
  }
};

export const setOrderCloseRequestAddFinished = (state, action) => {

  return state.setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'closeOrderRequestAddStarted'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'closeOrderRequestAddFinished'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'closeOrderRequestAddError'
  ], null).setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'details', 'closeOrderRequest'
  ], Immutable.fromJS(action.payload.closeOrderRequest));

};

export const setOrderCloseRequestAddFailed = (state, action) => {

  return state.setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'closeOrderRequestAddStarted'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'closeOrderRequestAddFinished'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'orderClose', 'closeOrderRequestAddError'
  ], 'Closing order failed.');

};

export const setInHomeAccess = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'inHomeAccessNeededToComplete'
  ], action.value);

  return setCloseStepValidation(state, action.orderId);
};



export const setDeliveryImage = (state, action) => {

  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofImageRequest',
    'imageBase64'
  ], action.payload.image).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofImageRequest',
    'orderId'
  ], action.orderId).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofImageRequest',
    'mimeType'
  ], action.payload.mimeType).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofDetails',
    'imageSet'], true);

  return setCloseStepValidation(state, action.orderId);
};

export const removeDeliveryImage = (state, action) => {
  state = state.removeIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofImageRequest',
    'imageBase64'
  ]).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofDetails',
    'imageSet'], false);

  return setCloseStepValidation(state, action.orderId);
};

export const setDeliveryDescription = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofImageRequest',
    'description'
  ], action.request.description).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofDetails',
    'validDescription'
  ], action.request.validDescription);

  return setCloseStepValidation(state, action.orderId);
};


export const deliveryProofSubmitStarted = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofDetails',
    'loading'
  ], true).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofDetails',
    'deliveryProofSubmitAttempted'
  ], true).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofDetails',
    'deliveryProofSubmitSuccess'
  ], false);

  return state;
};


export const deliveryProofSubmitFinished = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofDetails',
    'loading'
  ], false).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofDetails',
    'deliveryProofSubmitAttempted'
  ], true).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofDetails',
    'deliveryProofSubmitSuccess'
  ], true).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofDetails',
    'message'
  ], 'Delivery Proof Submitted Successfully');

  return setCloseStepValidation(state, action.orderId);
};


export const deliveryProofSubmitFailed = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofDetails',
    'loading'
  ], false).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofDetails',
    'deliveryProofSubmitAttempted'
  ], true).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofDetails',
    'deliveryProofSubmitSuccess'
  ], false).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofDetails',
    'message'
  ], 'Failed to Submit Delivery Proof');

  return setCloseStepValidation(state, action.orderId);
};

export const initDeliveryProof = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofImageRequest',
    'customerId'
  ], action.payload.customerId).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofImageRequest',
    'techId'
  ], action.payload.techId).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofImageRequest',
    'BillingSystem'
  ], action.payload.billingSystem).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofImageRequest',
    'MacAddresses'
  ], action.payload.macAddresses).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'deliveryProofAddMemoRequest'
  ], Immutable.fromJS(action.payload.deliveryProofAddMemoRequest)).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofImageRequest',
    'description'
  ], action.payload.deliveryProofAddMemoRequest.deliveryProofDescription);

  return setCloseStepValidation(state, action.orderId);
};

export const setNoAccessReason = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'commentRequest',
    'noAccessReasonId'
  ], action.payload);

  return setCloseStepValidation(state, action.orderId);
};

export const getNoAccessReasonListStarted = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'noAccessReasonDetails',
    'loading'
  ], true);

  return state;
};

export const getNoAccessReasonListFinished = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'noAccessReasonDetails',
    'loading'
  ], false).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'noAccessReasonDetails',
    'NoAccessReasonList'
  ], action.payload);

  return state;
};

export const getNoAccessReasonListFailed = (state, action) => {
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'noAccessReasonDetails',
    'loading'
  ], false);

  return state;
};

export const setDeliveryProofBypassFlag = (state, action) => {
  const deliveryProofDescription = action.request ? textUtils.workOrder.deliveryProofCheckbox : "";
  state = state.setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'deliveryProofAddMemoRequest',
    'deliveryProofBypassFlag'
  ], action.request).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'deliveryProofImageRequest',
    'description'
  ], deliveryProofDescription).setIn([
    'workOrderDetails',
    action.orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'deliveryProofAddMemoRequest',
    'deliveryProofDescription'
  ], deliveryProofDescription);

  return setCloseStepValidation(state, action.orderId);
}


// WEBPACK FOOTER //
// ./src/reducers/work-order/close.js